export default "__VITE_ASSET__DpepOrFE__"